var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruck3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.0005H12.1667H14V14.0005H3V10.0005Z",
    fill: "#3360AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66665 5.00049H3V9.00048H8V5.00049H7.16667H6.33331V6.60052H4.66665V5.00049Z",
    fill: "#3360AD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6667 5.00049H9V9.00048H14V5.00049H13.1667H12.3333V6.60052H10.6667V5.00049Z",
    fill: "#3360AD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 18.4999C21 20.433 19.433 22.0001 17.4999 22.0001C15.567 22.0001 14 20.433 14 18.4999C14 16.567 15.567 15 17.4999 15C19.433 15 21 16.567 21 18.4999ZM17.4999 19.9999C18.3284 19.9999 18.9999 19.3284 18.9999 18.4999C18.9999 17.6715 18.3284 16.9999 17.4999 16.9999C16.6716 16.9999 15.9999 17.6715 15.9999 18.4999C15.9999 19.3284 16.6716 19.9999 17.4999 19.9999Z",
    fill: "#1E3966"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 7V6H15V7V15H3H2H1V16.9999H2V18H5.08535C5.29127 17.4174 5.84688 16.9999 6.5 16.9999C7.15311 16.9999 7.70873 17.4174 7.91465 18H16H16.0853C16.2913 17.4174 16.8469 16.9999 17.5 16.9999C18.1531 16.9999 18.7087 17.4174 18.9146 18H22L22.4999 17.625L23 17.25V16.0001V15V12.2878L20.6498 7H17ZM17 9V13H20.9999V12.7122L19.3501 9H17Z",
    fill: "#1E3966"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18.4999C10 20.433 8.433 22.0001 6.5 22.0001C4.56701 22.0001 3 20.433 3 18.4999C3 16.567 4.56701 15 6.5 15C8.433 15 10 16.567 10 18.4999ZM6.5 19.9999C7.32843 19.9999 8 19.3284 8 18.4999C8 17.6715 7.32843 16.9999 6.5 16.9999C5.67158 16.9999 4.99999 17.6715 4.99999 18.4999C4.99999 19.3284 5.67158 19.9999 6.5 19.9999Z",
    fill: "#1E3966"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck3);
export default __webpack_public_path__ + "static/media/truck-3.0cb663231fda4353fc819f8b33894dc6.svg";
export { ForwardRef as ReactComponent };